import { render } from "./ModalRoot.vue?vue&type=template&id=0fa99ae5&scoped=true"
import script from "./ModalRoot.vue?vue&type=script&lang=js"
export * from "./ModalRoot.vue?vue&type=script&lang=js"

import "./ModalRoot.vue?vue&type=style&index=0&id=0fa99ae5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa99ae5"]])

export default __exports__